import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, catchError, Observable, of, tap } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { HttpService } from "../http.service";
import { CancelListResponse, CancelRecord } from "../../../models/admin/orders.model";
import { cancelInput, OrderListResponse } from "@sgm-frontend/core";


@Injectable({
    providedIn: 'root'
})
export class OrdersCancellationService extends HttpService<any | cancelInput, CancelListResponse> {
    private cancelListSubject = new BehaviorSubject<CancelListResponse | null>(null);
    readonly cancelList$ = this.cancelListSubject.asObservable();
    private orderListSubject = new BehaviorSubject<OrderListResponse | null>(null);
    readonly orderList$ = this.orderListSubject.asObservable();
    constructor(
        httpClient: HttpClient,
        @Inject('API_URL') apiUrl: string,
        @Inject('API_VERSION') apiVersion: string
    ) {
        super(httpClient, apiUrl, apiVersion, 'orders');
    }

    getAllCancellations(page = 1, limit = 10): Observable<CancelListResponse | null> {
        return this.getPagedGeneral('orders/cancel', page, limit).pipe(
            tap(response => this.cancelListSubject.next(response)),
            catchError(() => of(null))
        );
    }
    getFilteredCancel(entity: any): Observable<CancelListResponse | null> {
        return this.filterAllActionPaged(entity, 'cancel').pipe(
            tap((response) => this.cancelListSubject.next(response)),
            catchError(() => of(null))
        );
    }
    getCancelOrderByOrderId(orderId: number): Observable<CancelRecord> {
        return this.getById(orderId, 'cancel').pipe(catchError((error) => of(error)));
    }
    updateCancelOrderStatus(cancelInput: cancelInput): Observable<CancelRecord> {
        return this.update(cancelInput, 'cancel').pipe(catchError((error) => of(error)));
    }
    downloadCancellationOrders(params: any): Observable<Blob> {
        return this.downloadFileWithParams('orders/cancel/export', params);
    }
}